<app-cabecera></app-cabecera>

<div class="app-body">
  <router-outlet></router-outlet>
</div>

<app-pie></app-pie>
